import React from 'react';
import SettingTermsAndConditionsParentComponent from './settings-terms-and-conditions.component';

function SettingTermsAndConditions(props) {
    return <SettingTermsAndConditionsParentComponent />;
}

export default SettingTermsAndConditions;
